/* Returns the interection of several arrays */
export const intersection = arrays => {
  let [first, ...rest] = arrays
  rest = rest.map(x => new Set(x))
  return first.filter(x => rest.every(a => a.has(x)))
}

export const swapElements = (array, elem1, elem2) => {
  const res = [...array]
  let ind1 = -1
  let ind2 = -1
  for (const i in res) {
    const elem = res[i]
    if (elem === elem1) {
      ind1  = i
      if (ind2 !== -1) { break }
    } else if (elem === elem2) {
      ind2  = i
      if (ind1 !== -1) { break }
    }
  }
  if (ind1 !== -1 && ind2 !== -1) {
    const temp = res[ind1]
    res[ind1] = res[ind2]
    res[ind2] = temp
  }
  return res
}